
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.586 6L.343 1.757A1 1 0 011.758.343L6 4.586 10.243.343a1 1 0 111.414 1.414L7.414 6l4.243 4.243a1 1 0 01-1.414 1.414L6 7.414l-4.242 4.243a1 1 0 01-1.415-1.414L4.586 6z","fill":"#808393"}})])
          )
        }
      }
    